import { createHttpClient } from '@adapters/HttpClient';
import { toast } from '@shared/hooks/use-toast';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { NotificationsApiAdapter } from '../adapters/NotificationsApiAdapter';
import type { UpdatePreferenceRequest } from '../models/Notification.types';

export const useUpdatePreference = () => {
  const { t } = useTranslation('notificationsModule');
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new NotificationsApiAdapter(httpClient);

  return useMutation({
    mutationFn: (data: UpdatePreferenceRequest) => adapter.updatePreference(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notification-preferences'] });
      toast({
        variant: 'success',
        title: t('notifications.preferences.saved'),
      });
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: t('notifications.preferences.error'),
      });
    },
  });
};
